const styles = (theme) => ({
  dataGrid: {
    minHeight: 150,
    height: 180,
    maxHeight: 240,
    border: `1px solid ${theme.AppBGColor}`,
    '& .ag-theme-material .ag-body-horizontal-scroll': {
      borderWidth: '0px'
    },
    [`&>.gridTheme-${theme.themeName}>.ag-theme-material.theme-${theme.themeName}`]: {
      height: '100%',
    },
    '& .statusBar': {
      display: 'none'
    },
    '& .ag-center-cols-viewport': {
      width: `calc(100% + 18px)`
    }
  },
  receiverGrid: {
    margin: '20 0 60 0',
    height: 300
  },
  paperAnchor: {
    position: "absolute",
    width: 380,
    zIndex: 100,
    backgroundColor: theme.ModalBGColor,
    border:`1px solid ${theme.AppBGColor}`
  },
});

export default styles;
